import React from "react";
import questiontwo from "../../assets/images/Icon (2).svg";
import deleteIcon from "../../assets/images/delete.svg";
import question from "../../assets/images/Icon (1).svg";

const ConfiramtionModal = ({ confirmationAction, onClose, onSubmit }) => {
  return (
    <div
      id="default-modal"
      aria-hidden="true"
      className="fixed inset-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50"
    >
      {confirmationAction.action === "block" ? (
        <div className="relative p-4 w-full max-w-2xl max-h-full">
          <div className="relative bg-white rounded-lg shadow ">
            <div className="flex items-center justify-center p-4 md:p-5 rounded-t ">
              <img src={questiontwo} alt="logo" className="mx-auto w-20 h-20" />
              <button
                onClick={onClose}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute right-4 top-4 inline-flex justify-center items-center :bg-gray-600 :text-white"
                data-modal-hide="default-modal"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            <div className="p-4 md:p-5 space-y-4 flex flex-col items-center justify-center">
              <h3 className="text-xl font-semibold text-gray-900 ">
                Block
              </h3>
              <p className="text-base text-center leading-relaxed text-gray-500 ">
                Are you sure you want to Block ?
              </p>
              <p className="w-[480px] text-base text-center leading-relaxed text-gray-500 ">
                Blocking this user will revoke their access and permissions.
                They will no longer be able to access the system or perform any
                actions.This action can be reversed anytime by unblocking the
                user
              </p>
            </div>
            <div>
              <p className="text-base text-center leading-relaxed text-gray-500 ">
                This action can be reversed anytime.
              </p>
            </div>

            <div className="flex border-t-2 justify-end items-center p-4 md:p-5 border-gray-200 rounded-b ">
              <button
                data-modal-hide="default-modal"
                type="button"
                className="py-2.5 mr-5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-4 focus:ring-gray-100 :ring-gray-700    :text-white :bg-gray-700"
                onClick={onClose}
              >
                Dismiss
              </button>
              <button
                data-modal-hide="default-modal"
                type="button"
                className="text-white bg-[#DF1C41] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  :ring-blue-800"
                onClick={onSubmit}
              >
                Block
              </button>
            </div>
          </div>
        </div>
      ) : confirmationAction.action === "delete" ? (
        <div className="relative p-4 w-full max-w-xl max-h-full">
          <div className="relative bg-white rounded-lg shadow ">
            <div className="flex items-center justify-center p-4 md:p-5 rounded-t ">
              <img src={deleteIcon} alt="logo" className="mx-auto w-20 h-20" />
              <button
                onClick={onClose}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute right-4 top-4 inline-flex justify-center items-center :bg-gray-600 :text-white"
                data-modal-hide="default-modal"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            <div className="md:p-5 space-y-4 flex flex-col items-center justify-center">
              <h3 className="text-xl font-semibold text-gray-900 ">
                Delete
              </h3>
              <p className="text-base text-center leading-relaxed text-gray-500 ">
                Are you sure you want to delete this user?
              </p>
              {/* <p className="w-[480px] text-base text-center leading-relaxed text-gray-500 ">
                Blocking this user will revoke their access and permissions.
                They will no longer be able to access the system or perform any
                actions.This action can be reversed anytime by unblocking the
                user
              </p> */}
            </div>
            {/* <div>
              <p className="text-base text-center leading-relaxed text-gray-500 ">
                This action can be reversed anytime.
              </p>
            </div> */}

            <div className="flex border-t-2 justify-end items-center p-4 md:p-5 border-gray-200 rounded-b ">
              <button
                data-modal-hide="default-modal"
                type="button"
                className="py-2.5 mr-5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-4 focus:ring-gray-100 :ring-gray-700    :text-white :bg-gray-700"
                onClick={onClose}
              >
                Dismiss
              </button>
              <button
                data-modal-hide="default-modal"
                type="button"
                className="text-white bg-[#DF1C41] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  :ring-blue-800"
                onClick={onSubmit}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="relative p-4 w-full max-w-2xl max-h-full">
          <div className="relative bg-white rounded-lg shadow ">
            {/* Modal Header */}
            <div className="flex items-center justify-center p-4 md:p-5 rounded-t ">
              <img src={question} alt="logo" className="mx-auto w-20 h-20" />
              <button
                onClick={onClose}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute right-4 top-4 inline-flex justify-center items-center :bg-gray-600 :text-white"
                data-modal-hide="default-modal"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-4 md:p-5 space-y-4 flex flex-col items-center justify-center">
              <h3 className="text-xl font-semibold text-gray-900 ">
                Unblock
              </h3>
              <p className="text-base text-center leading-relaxed text-gray-500 ">
                Are you sure you want to unblock?
              </p>
              <p className="w-[480px] text-base text-center leading-relaxed text-gray-500 ">
                Unblocking this user will restore their access and permissions
                previously assigned.
              </p>
            </div>
            <div>
              <p className="text-base text-center leading-relaxed text-gray-500 ">
                This action can be reversed anytime.
              </p>
            </div>

            {/* Modal Footer */}
            <div className="flex border-t-2 justify-end items-center p-4 md:p-5 border-gray-200 rounded-b ">
              <button
                data-modal-hide="default-modal"
                type="button"
                className="py-2.5 mr-5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-4 focus:ring-gray-100 :ring-gray-700    :text-white :bg-gray-700"
                onClick={onClose}
              >
                Dismiss
              </button>
              <button
                data-modal-hide="default-modal"
                type="button"
                className="text-white bg-[#2D9F75]  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  :bg-blue-700 :ring-blue-800"
                onClick={onSubmit}
              >
                Unblock
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfiramtionModal;
